export const AcceptTypes = {
  FILE: 'jpg,jpeg,png,txt,pdf,rar,xls,xlsx,ppt,pptx,zip,doc,docx,msg,eml,bmp',
  IMAGE: 'jpg,jpeg,png,gif,svg,bmp'
}
export const GetFileIcon = function (type) {
  const icon = {
    img: '-25px -40px',
    txt: '-5px -60px',
    pdf: '-25px 0px',
    zip: '-5px -40px',
    mail: '-25px -60px',
    word: '-25px -20px',
    excel: '-5px 2px',
    ppt: '-5px -20px'
  }
  const object = {
    img: ['jpg', 'jpeg', 'png', 'bmp'],
    txt: ['txt'],
    pdf: ['pdf'],
    zip: ['rar', 'zip'],
    mail: ['msg', 'eml'],
    word: ['doc', 'docx'],
    excel: ['xls', 'xlsx'],
    ppt: ['ppt', 'pptx']
  }
  
  for (const key in object) {
    if (Object.hasOwnProperty.call(object, key)) {
      const item = object[key]
      if (item.includes(type.toLowerCase())) {
        return icon[key]
      }
    }
  }
}
